import React, { Fragment } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import VpnKeyOutlined from '@material-ui/icons/VpnKeyOutlined';
import ExitToApp from '@material-ui/icons/ExitToApp';
import LanguageOutlinedIcon from '@material-ui/icons/LanguageOutlined';
import { makeStyles } from '@material-ui/styles';
import { injectIntl } from 'react-intl';
import { getUser } from '../utilties/userUtilities';
import history from '../utilties/history'
import { signOut, showModal, home } from '../redux/actions';
import { caseSelector, currentCaseSelector } from '../redux/selectors';
import CaseInformation from '../components/CaseInformation';
import ChangePassword from '../pages/templates/components/ChangePassword';
import ChangeLanguage from '../pages/templates/components/ChangeLanguage';
import { useLocation } from 'react-router';
import clsx from 'clsx'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import { IconButton, MenuItem } from '@material-ui/core';
import MuiMenu from '@material-ui/core/Menu'
import RequestAccountDeletion from '../pages/templates/components/RequestAccountDeletion';

const useStyles = makeStyles((theme) => ({
  buttonIcon: {
    color: theme.palette.text.primary,
    fontSize: '17px',
    fontWeight: 'bold',
    margin: '0 10px',
    textAlign: 'left',
    '& svg': {
      color: theme.palette.text.primary,     
    },
    minWidth: '0px',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#000',
      '& svg': {
        color: '#000',
      },
    },
    '&:focus': {
      backgroundColor: 'transparent',
      color: '#000',
      '& svg': {
        color: '#000',
      },
    },
    '& .MuiButton-label:after': {
      display: 'none',
    }
  },
  buttonLink: {
    borderRadius: '0',
    color: theme.palette.text.primary,
    fontSize: '17px',
    fontWeight: 'bold',
    minWidth: '0px',
    margin: '0 21px -4px',
    borderBottom: '4px transparent solid',
    padding: '3px 0',
    '&:hover': {
      borderBottom: '4px #007AFF solid',
      backgroundColor: 'transparent',
      color: '#000',
    },
    '&:focus': {
      borderBottom: '4px #007AFF solid',
      backgroundColor: 'transparent',
      color: '#000',
    },
    '& .MuiButton-label:after': {
        display: 'none',
    }
  },
  separator: {
    background: '#EEF1F9',
    width: '1px',
    height: '84px',
    margin: '0 10px',
  },
  menuWrapper: {
    display: 'flex',
    alignItems: 'center',
  }
}));

const ITEM_HEIGHT = 48

const AccountMenu = ({ 
  intl, 
  home, 
  signOut, 
  onInfoClick, 
  data, 
  currentCase, 
  onChangePasswordClick, 
  onChangeLanguageClick, 
  onChangeCaseClick, 
  hidePagesMenu, 
  isExternalAuth,
  onAccountDeletionClick,
  canChangeLanguage = true,
  canChangePassword = true,
  disablePagesMenu = false
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [user, setUser] = React.useState(getUser());
  const classes = useStyles();
  const location = useLocation()

  const open = Boolean(anchorEl)

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const load = url =>
  {
    history.push(url)
  }

  const getMenuStyle = url => {
    return location.pathname === url ? { borderBottom: '4px #007AFF solid', color: '#000' } : {}
  }

  const changePasswordHandler = () => {
			onChangePasswordClick()
			handleClose()
	}

  const accountDeletionHandler = () => {
			onAccountDeletionClick()
			handleClose()
	}

  return (
    <div className={clsx(classes.menuWrapper, `mainHeaderMenuMobile-menuWrapper`)}>

          {
              !hidePagesMenu &&
              (
                  <React.Fragment>
                      {!isExternalAuth && <Button
                          disabled={disablePagesMenu}
                          onClick={() => load('/')}
                          data-testid='button-account-menu-home' variant="text" size="large" className={clsx(classes.buttonLink, `mainHeaderMenuMobile-buttonLink`)} >
                          {intl.formatMessage({ id: `app.menu.home` })}
                      </Button>}
                      <Button
                          disabled={disablePagesMenu}
                          variant="text" size="large" onClick={() => load('/scores')} className={clsx(classes.buttonLink, `mainHeaderMenuMobile-buttonLink`)}  style={getMenuStyle('/scores')}>
                          {intl.formatMessage({ id: `app.menu.scores` })}
                      </Button>
                      <Button
                          disabled={disablePagesMenu}
                          variant="text" size="large" onClick={() => load('/albums')} className={clsx(classes.buttonLink, `mainHeaderMenuMobile-buttonLink`)}  style={getMenuStyle('/albums')}>
                          {intl.formatMessage({ id: `app.menu.images` })}
                      </Button>
                      <Button
                          disabled={disablePagesMenu}
                          variant="text" size="large" onClick={() => load('/case')} className={clsx(classes.buttonLink, `mainHeaderMenuMobile-buttonLink`)}  style={getMenuStyle('/case')}>
                          {intl.formatMessage({ id: `app.menu.case` })}
                      </Button>
                  </React.Fragment>
              )
          }
          
      {!isExternalAuth &&
        <Fragment>
          {
            (
              canChangeLanguage
              || canChangePassword
            )
            && <div className={clsx(classes.separator, `mainHeaderMenuMobile-separator`)}></div>
          }

          {
            canChangeLanguage
            && <Button onClick={() => onChangeLanguageClick()}
              data-testid='button-account-change-language' aria-label="Change language" className={clsx(classes.buttonIcon, `mainHeaderMenuMobile-buttonIcon`)}>
              <LanguageOutlinedIcon style={{ fontSize: '22px' }} />
            </Button>
          }

          {/* {
            canChangePassword
            && <Button onClick={() => onChangePasswordClick()}
              data-testid='button-account-change-password' aria-label="Change password" className={clsx(classes.buttonIcon, `mainHeaderMenuMobile-buttonIcon`)}>
              <VpnKeyOutlined style={{ fontSize: '22px' }} />
            </Button>
          } */}

          {
            !disablePagesMenu && canChangePassword && <div>
            <IconButton aria-label='more' aria-controls='long-menu' aria-haspopup='true' onClick={handleClick} className={clsx(classes.buttonIcon, `mainHeaderMenuMobile-buttonIcon`)}>
              <SettingsOutlinedIcon style={{ fontSize: '22px' }} />
            </IconButton>
            <MuiMenu
              id='long-menu'
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: 220,
                  //backgroundColor: '#243041',
                  //color: '#fff'
                }
              }}>
              {canChangePassword &&
                <MenuItem
                  data-testid="change-password-menu-item"
                  onClick={changePasswordHandler}>
                  {intl.formatMessage({ id: 'app.general.changePasswordMenuItem' })}
                </MenuItem>}
              {canChangePassword &&
                <MenuItem
                  data-testid="account-deletion-menu-item"
                  onClick={accountDeletionHandler}>
                  {intl.formatMessage({ id: 'app.general.accountDeletionMenuItem' })}
                </MenuItem>}
            </MuiMenu>
          </div>
          }

          {
            !!user
            && <Fragment>
              <div className={clsx(classes.separator, `mainHeaderMenuMobile-separator`)}></div>
              <Button data-testid='button-account-menu-exit' variant="text" size="large" onClick={() => signOut()} className={clsx(classes.buttonIcon, `mainHeaderMenuMobile-buttonIcon`)}>
                <ExitToApp style={{ fontSize: '22px', marginRight: '12px' }} />
                {intl.formatMessage({ id: `app.menu.logout` })}
              </Button>
            </Fragment>
          }
        </Fragment>}

      {/* {data && data.id > 0 && (
        <Button data-testid='button-account-menu-info' aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} className={clsx(classes.buttonLink, `mainHeaderMenuMobile-buttonLink`)} >
          <Grid container justify="space-around" alignItems="flex-start">
            <Grid item>
              <InfoOutlined onClick={() => onInfoClick} style={{fontSize: '22px' }} />
            </Grid>
          </Grid>
        </Button>
      )} */}
      {/* <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose} style={{ color: 'white' }}>
        <CaseInformation />
      </Menu> */}

    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
    data: caseSelector(state),
    currentCase: currentCaseSelector(state)
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    home: () => dispatch(home()),
    signOut: () => dispatch(signOut()),
    onInfoClick: () => dispatch(showModal(CaseInformation)),
    onChangePasswordClick: () => dispatch(showModal(ChangePassword)),
    onChangeLanguageClick: () => dispatch(showModal(ChangeLanguage)),
    onAccountDeletionClick: () => dispatch(showModal(RequestAccountDeletion))
});

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl);

export default enhance(AccountMenu);
